import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DashboardService } from '../../../dashboard/dashboard.service';
import { BookManagementService } from '../../book-management.service';

@Component({
  selector: 'app-contract-stats',
  templateUrl: './contract-stats.component.html',
  styleUrls: ['./contract-stats.component.scss'],
  standalone: false,
})
export class ContractStatsComponent implements OnInit, OnDestroy {
  private bmSvc = inject(BookManagementService);
  private cdRef = inject(ChangeDetectorRef);
  private dbs = inject(DashboardService);

  @Input() reportName;
  unsubscribe: Subject<any> = new Subject();
  contractAmount = 0;
  totalPremium = 0;
  contractCount = 0;
  loading = true;
  filterValues = {};

  ngOnInit(): void {
    this.bmSvc.updateBmWidgets$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(filterVals => {
        this.filterValues = filterVals;
        this.getContractStats();
      });
  }

  getContractStats() {
    this.loading = true;
    const reportParams = {
      take: 10,
      skip: 0,
      search: { unitId: { searchString: this.filterValues['unitId'] } },
      name: this.reportName,
    };
    const selectionVars = [
      'npn',
      'accountType',
      'productType',
      'carrier',
      'productName',
      'userId',
    ];

    selectionVars.map(varName => {
      if (this.filterValues[varName] && this.filterValues[varName].length > 0) {
        reportParams['search'][varName] = {
          selected: this.filterValues[varName],
        };
      }
    });

    if (this.filterValues['start'] && this.filterValues['end']) {
      reportParams['search']['SavedTime'] = {
        start: this.filterValues['start'],
        end: this.filterValues['end'],
      };
    }

    this.dbs.getDynamicReport(reportParams).subscribe({
      next: resp => {
        if (resp && resp['data'] && resp['data'].length > 0) {
          this.contractAmount = resp['data'][0]['contractAmount'] * 1;
          this.totalPremium = resp['data'][0]['totalPremium'] * 1;
          this.contractCount = resp['data'][0]['contractCount'] * 1;
        }
        if (resp && resp['dropdowns']) {
          this.bmSvc.updateBmWidgetOptions(resp['dropdowns']);
        }
        this.loading = false;
        this.cdRef.detectChanges();
      },
      error: err => {
        console.warn(err);
        this.loading = false;
      },
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }
}
